module.exports = __webpack_public_path__ + "img/taoyuan-1.905f365b.jpg";